import { Button, Col, Divider, Form, Input, message } from "antd";
import type React from "react";
import { useAudienceModalContext } from "../../providers/AudienceModalContext";
import type { AudienceContextValue } from "../../types";

export interface AudienceModalActionsProps {
	onCreate?: (...args: any) => void;
	onBack?: () => void;
	createButtonText?: string;
	showDivider?: boolean;
	isLoading?: boolean;
	searchResults?: AudienceContextValue["hooks"]["searchAudienceMutation"]["data"];
}

const AudienceModalActions: React.FC<AudienceModalActionsProps> = ({
	onCreate,
	onBack,
	createButtonText = "作成",
	showDivider = true,
	isLoading = false,
	searchResults,
}) => {
	const { step, setStep, searchForm, createForm, type, publicSettings } =
		useAudienceModalContext<{}, { name: string }>();

	const isViewMode = type === "view";
	const searchResultsCount = searchResults?.count || 0;

	const handleCreate = () => {
		const count = searchResultsCount;
		if (count > 0) {
			setStep("create");
		} else {
			message.warning("該当者0人でオーディエンスを作成することはできません");
		}
	};

	const handleBack = () => {
		if (onBack) {
			onBack();
		} else {
			setStep("search");
		}
	};

	const handleSubmit = async (
		createFormValues: Awaited<ReturnType<typeof createForm.validateFields>>,
	) => {
		if (onCreate) {
			const searchFormValues = searchForm.getFieldsValue(true);
			await onCreate({ ...searchFormValues, ...createFormValues });
		}
	};

	if (step === "search") {
		return (
			<>
				{showDivider && <Divider />}
				<Col span={24} className="text-center">
					<Button
						type="primary"
						size="large"
						className="px-12"
						onClick={handleCreate}
					>
						{createButtonText}
					</Button>
				</Col>
			</>
		);
	}

	// TODO: Potentially convert this to configurable antd modal.confirm
	if (step === "create") {
		return (
			<div>
				<Form
					form={createForm}
					layout="vertical"
					disabled={isViewMode}
					onFinish={handleSubmit}
				>
					<Form.Item
						name="audienceName"
						label="オーディエンス名"
						rules={[
							{
								required: true,
								message: "オーディエンス名を入力してください",
							},
							{
								max: 50,
								message: "オーディエンス名は50文字以内で入力してください",
							},
						]}
					>
						<Input placeholder="例: アクティブ会員" maxLength={50} />
					</Form.Item>

					{!isViewMode && (
						<div className="flex justify-end gap-4 mt-6">
							<Button onClick={handleBack}>条件を再設定</Button>
							<Button
								type="primary"
								htmlType="submit"
								loading={isLoading}
								style={{
									backgroundColor: publicSettings?.PRIMARY_COLOR?.valueString,
									borderColor: publicSettings?.PRIMARY_COLOR?.valueString,
								}}
							>
								確認
							</Button>
						</div>
					)}
				</Form>
			</div>
		);
	}

	return null;
};

export default AudienceModalActions;
